import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { API_CONFIG } from '../../utils/constants';

// Crear instancia de axios
const apiClient: AxiosInstance = axios.create({
    baseURL: API_CONFIG.BASE_URL,
    timeout: API_CONFIG.TIMEOUT,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Interceptor para requests (agregar token, logs, etc.)
apiClient.interceptors.request.use(
    (config: any) => {
        // Agregar token si existe
        const token = localStorage.getItem('token');
        if (token && config.headers) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        
        if (API_CONFIG.ENVIRONMENT === 'development') {
            console.log('API Request:', config);
        }
        
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);


    // Interceptor para responses (manejo de errores globales)
apiClient.interceptors.response.use(
    (response: AxiosResponse) => {
        if (API_CONFIG.ENVIRONMENT === 'development') {
            console.log('API Response:', response);
        }
        return response;
    },
    (error) => {
        // Manejo global de errores
        if (error.response?.status === 401) {
            // Redirect to login o limpiar token
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        
        console.error('API Error:', error);
        return Promise.reject(error);
    }
);

export default apiClient;